"use client";

import React, { useState } from 'react';
import Link from 'next/link';

const DiamondIcon = ({ hovered }) => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ filter: hovered ? 'none' : 'drop-shadow(0 2px 4px rgba(0,0,0,0.4))', flexShrink: 0 }}
  >
    <polygon points="12,3 7,8 12,10 17,8" fill="#fee6c4" opacity="0.95" />
    <polygon points="3,8 7,3 12,3 7,8" fill="#fde8cb" opacity="0.75" />
    <polygon points="21,8 17,3 12,3 17,8" fill="#d4a070" opacity="0.75" />
    <polygon points="3,8 7,8 12,10" fill="#fad5b2" opacity="0.88" />
    <polygon points="21,8 17,8 12,10" fill="#c8885a" opacity="0.88" />
    <polygon points="3,8 12,10 12,21" fill="#f0c49a" opacity="0.92" />
    <polygon points="21,8 12,10 12,21" fill="#b87040" opacity="0.92" />
  </svg>
);

const BirthstoneButton = () => {
  const [hovered, setHovered] = useState(false);

  return (
    <>
      <style>{`
        @keyframes shimmer-border {
          0%   { background-position: 0% 50%; }
          50%  { background-position: 100% 50%; }
          100% { background-position: 0% 50%; }
        }
        .birthstone-btn::before {
          content: '';
          position: absolute;
          inset: -1px;
          border-radius: 9999px;
          padding: 1px;
          background: linear-gradient(
            120deg,
            rgba(255,230,196,0.55) 0%,
            rgba(212,160,112,0.35) 30%,
            rgba(255,230,196,0.15) 55%,
            rgba(212,160,112,0.45) 80%,
            rgba(255,230,196,0.55) 100%
          );
          background-size: 250% 250%;
          animation: shimmer-border 4s linear infinite;
          -webkit-mask:
            linear-gradient(#fff 0 0) content-box,
            linear-gradient(#fff 0 0);
          -webkit-mask-composite: xor;
          mask-composite: exclude;
          pointer-events: none;
        }
      `}</style>

      <Link
        href="/birthstone"
        aria-label="Explore Birthstones"
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        className="
          birthstone-btn
          fixed bottom-4 left-4
          sm:bottom-6 sm:left-6
          z-50
          flex items-center gap-2.5
          rounded-full
          overflow-hidden
          h-12 sm:h-14
          px-3.5 sm:px-4
          max-w-[3rem] sm:max-w-[3.5rem]
          hover:max-w-[15rem]
          group
        "
        style={{
          background: 'rgba(40, 22, 10, 0.55)',
          backdropFilter: 'blur(16px) saturate(180%)',
          WebkitBackdropFilter: 'blur(16px) saturate(180%)',
          boxShadow: hovered
            ? '0 4px 24px rgba(212,160,112,0.25), 0 1px 0 rgba(255,255,255,0.08) inset, 0 0 0 1px rgba(255,220,180,0.2)'
            : '0 8px 32px rgba(0,0,0,0.3), 0 1px 0 rgba(255,255,255,0.12) inset, 0 0 0 1px rgba(255,220,180,0.15)',
          transform: hovered ? 'translateY(2px) scale(1.03)' : 'translateY(0) scale(1)',
          transition: 'transform 0.2s ease, box-shadow 0.2s ease, max-width 0.35s cubic-bezier(0.22,1,0.36,1), background 0.2s ease',
          textDecoration: 'none',
          position: 'fixed',
        }}
      >
        {/* Glass inner highlight */}
        <span style={{
          position: 'absolute',
          inset: 0,
          borderRadius: '9999px',
          background: 'linear-gradient(160deg, rgba(255,255,255,0.18) 0%, rgba(255,255,255,0.04) 50%, transparent 100%)',
          pointerEvents: 'none',
        }} />

        {/* Warm glow on hover */}
        <span style={{
          position: 'absolute',
          inset: 0,
          borderRadius: '9999px',
          background: hovered
            ? 'radial-gradient(ellipse at 30% 50%, rgba(212,160,112,0.18) 0%, transparent 70%)'
            : 'transparent',
          transition: 'background 0.3s ease',
          pointerEvents: 'none',
        }} />

        {/* Diamond icon */}
        <span className="flex-shrink-0 flex items-center justify-center relative z-10">
          <DiamondIcon hovered={hovered} />
        </span>

        {/* Label */}
        <span
          className="
            whitespace-nowrap text-sm font-semibold tracking-wide
            hidden sm:block
            overflow-hidden
            transition-all duration-300
            max-w-0 group-hover:max-w-[11rem]
            opacity-0 group-hover:opacity-100
            relative z-10
          "
          style={{
            color: '#fee6c4',
            textShadow: '0 1px 8px rgba(0,0,0,0.4)',
            fontFamily: "'Montserrat', sans-serif",
            letterSpacing: '0.06em',
          }}
        >
          Explore Birthstones
        </span>
      </Link>
    </>
  );
};

export default BirthstoneButton;